export type TResponeData<T> = {
	data: T
	error: string | null
	success: boolean
}

export interface IIndustry {
	industryId: number | null
	industryName: string | null
	industryNameEn: string | null
	orderIndustry: number | null
}
export interface ILevel {
	levelAlias: string
	levelName: string
	levelOrder: number
}

export interface IRulingNumberItem {
	title: string | null
	content: string | null
}
export interface IRulingNumber {
	number: number | null
	description: string | null
	descriptionPersonalities: string | null
	items: IRulingNumberItem[] | null
}

export interface IBodyCheckingNumerology {
	fullName: string
	birthday: string
	industryId: number
	levelName: string
}
export interface ICheckingNumerology {
	userId: number | null
	fullName: string | null
	birthday: string | null
	industryId: number | null
	levelId: number | null
	rulingNumber: number | null
	missionNumber: number | null
	attitudeNumber: number | null
	birthdayNumber: number | null
	createdOn: string | null
	updatedOn: string | null
}
export interface ICareerPathDetail {
	industryId: number | null
	levelName: string | null
	content: string | null
	degree: string | null
	experienceRange: string | null

	industryName: string | null
	industryNameEn: string | null
	industryParentId: number | null
	industryParentName: string | null

	levelOrder: string | null
}
export enum ENumerologyDataKey {
	rulingNumberData = 'rulingNumberData',
	missionNumberData = 'missionNumberData',
	attitudeNumberData = 'attitudeNumberData',
	birthdayNumberData = 'birthdayNumberData'
}

export enum ENumerologyKey {
	rulingNumber = 'rulingNumber',
	missionNumber = 'missionNumber',
	attitudeNumber = 'attitudeNumber',
	birthdayNumber = 'birthdayNumber'
}

export type TUserInfo = {
	userId: number
	fullName: string
	birthday: string
	industryId: number
	industryName: string
	levelAlias: string
	levelName: string
	rulingNumber: number
	missionNumber: number
	attitudeNumber: number
	birthdayNumber: number
}

export type TNumberMeaningItem = {
	title: string
	content: string
}

export type TNumberMeaning = {
	number: number
	description: string
	descriptionPersonalities: string
	items: TNumberMeaningItem[]
}

export interface INumerologyDetail {
	userInfo: TUserInfo
	rulingNumberData: TNumberMeaning
	missionNumberData: TNumberMeaning
	attitudeNumberData: TNumberMeaning
	birthdayNumberData: TNumberMeaning
}

export type TUserInfoInNumerlogy = {
	userInfo: {
		attitudeNumber: number | null
		birthday: string | null
		birthdayNumber: number | null
		fullName: string | null
		industryId: number | null
		industryName: string | null
		industryNameEn: string | null
		levelAlias: string | null
		levelName: string | null
		missionNumber: number | null
		rulingNumber: number | null
		userId: number | null
	}
}

export type TNumerologyDetail = {
	[key in ENumerologyDataKey]: {
		number: number | null
		description: string | null
		descriptionPersonalities: string | null
		items: IRulingNumberItem[] | null
	}
}

export enum EPageTypeFamousPeople {
	HomePage = 'HomePage',
	Other = 'Other',
	All = 'All'
}

export interface IFamousPeople {
	id: number | null
	rulingNumber: number | null
	title: string | null
	fullName: string | null
	images: string | null
	birthday: string | null
}

export enum EColorChart {
	'#ED1C24',
	'#A2F6BE',
	'#005AFF',
	'#FAE18F',
	'#3CAAFF'
}
export interface ICronJobNumerology extends Omit<IIndustry, 'orderIndustry'> {
	rate: number | null
}

export interface IDataChartNumerology extends ICronJobNumerology {
	color: string
}
